<template>
  <v-list dense class="noPadding" style="height: 100%">
    <template v-for="item in items">
      <!--<v-layout row
        v-if="item.heading"
        align-center
        :key="item.heading">
        <v-flex xs6>
          <v-subheader v-if="item.heading">
            {{ item.heading }}
          </v-subheader>
        </v-flex>
        <v-flex xs6 class="text-xs-center">
          <a href="#!" class="body-2 black--text">EDIT</a>
        </v-flex>
      </v-layout>
      -->

      <v-list-group v-if="item.children"
                    v-model="item.model"
                    :key="item.text"
                    :prepend-icon="item.model ? item.icon : item['icon-alt']"
                    :append-icon="item.model ? item.iconend : item['iconend-alt']">
        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title>
              {{ item.text }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-for="(child, i) in item.children"
                     :key="i"
                     :to="child.link"
                     @click="">
          <v-list-tile-action v-if="child.icon" class="text-xs-center">
            <v-icon>{{ child.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ child.text }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>
      <v-list-tile v-else @click="" :to="item.link" :key="item.text">
        <v-list-tile-action class="text-xs-center">
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>
            {{ item.text }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

    </template>
  </v-list>
</template>

<script>

  import { sharedJS } from '../sharedJS.js'

  export default {

    data() {
      return {
        items: []

      }
    },
    beforeMount() {

      //Gets Menu Items From SharedJS File
      this.items = sharedJS.mainMenuItems().items

    }

  }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/navigationPages/MainNav.vue